import appApi from "@/api/system/app";
// 日期快捷选项
export const pickerOptions = {
  shortcuts: [
    {
      text: "最近一周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近两周",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit("pick", [start, end]);
      }
    },
    {
      text: "最近一个月",
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit("pick", [start, end]);
      }
    }
  ]
};

// echart文字标注
export const labelOption = {
  normal: {
    label: {
      show: true, //开启显示
      position: "top", //在上方显示
      textStyle: {
        //数值样式
        color: "black",
        fontSize: 10
      }
    }
  }
};

// 获取游戏列表
export function getAppList() {
  let appInfo = JSON.parse(localStorage.getItem("appInfo"));
  return appInfo.appList;
}

// 获取全部渠道
export function getAllChnList() {
  let appInfo = JSON.parse(localStorage.getItem("appInfo"));
  return appInfo.chnList;
}

// 根据app获取渠道
export function getChnList(app) {
  let appInfo = JSON.parse(localStorage.getItem("appInfo"));
  let chnList = [];
  appInfo.appChnList.forEach(index => {
    if (index.app === app) {
      chnList = index.chnList;
    }
  });
  return chnList;
}

// 根据app获取场景(加'全部'选项)
export function getAllSceneList(app) {
  let appInfo = JSON.parse(localStorage.getItem("appInfo"));
  let sceneList = [];
  appInfo.appSceneList.forEach(index => {
    if (index.app === app) {
      sceneList = index.sceneList;
    }
  });
  sceneList.unshift({ value: null, label: "全部" });
  return sceneList;
}

// 根据app获取场景
export function getSceneList(app) {
  let appInfo = JSON.parse(localStorage.getItem("appInfo"));
  let sceneList = [];
  appInfo.appSceneList.forEach(index => {
    if (index.app === app) {
      sceneList = index.sceneList;
    }
  });
  return sceneList;
}

// 转换值为标签
export function formatValueToLabel(value, list) {
  let label = value;
  list.forEach(element => {
    if (element.value == value) {
      label = element.label;
    }
  });
  return label;
}

// 转换标签为值
export function formatLabelToValue(label, list) {
  let value = value;
  list.forEach(element => {
    if (element.label == label) {
      value = element.value;
    }
  });
  return value;
}

// 获取默认渠道
export function getDefaultChn(app) {
  let appInfo = JSON.parse(localStorage.getItem("appInfo"));
  let chn = "IOS";
  appInfo.appChnList.forEach(element => {
    if (element.app == app) {
      chn = element.defaultChn;
    }
  });
  // 获取用户上一次选取的渠道信息
  let lastChnInfo = JSON.parse(localStorage.getItem("lastChnInfo"));
  if (lastChnInfo && lastChnInfo.app == app && lastChnInfo.chn) {
    chn = lastChnInfo.chn
  }
  return chn;
}



// WEBPACK FOOTER //
// ./src/utils/format.js